export const GET_CUSTOMERS = "GET_CUSTOMERS"
export const GET_CUSTOMER = "GET_CUSTOMER"

export const UPDATE_JOB = "UPDATE_JOB"
export const DELETE_CUSTOMER = "DELETE_CUSTOMER"